import { useQuery } from '@tanstack/react-query';

import { readShigoAppConfig } from '../../../lib/config';
import { useShigoSession } from '../../../lib/useShigoSession';
import type { ReportRequest } from '../reportExplorer/model';
import { createPerformanceAnalyzerClient } from './api';

export enum PerformanceQueryKind {
  Standard = 'STANDARD',
  TopStitcherPublishers = 'TOP_STITCHER_PUBLISHERS',
  StitcherPlacements = 'STITCHER_PLACEMENTS',
}

export const performanceAnalyzerQueryKey = ['reporting', 'performance-analyzer'] as const;

export function usePerformanceQuery(
  kind: PerformanceQueryKind,
  request: ReportRequest,
  enabled = true,
) {
  const client = usePerformanceAnalyzerClient();
  return useQuery({
    queryKey: [...performanceAnalyzerQueryKey, kind, request],
    queryFn: () => {
      if (kind === PerformanceQueryKind.TopStitcherPublishers) {
        return client.topStitcherPublishers(request);
      }
      if (kind === PerformanceQueryKind.StitcherPlacements) {
        return client.stitcherPlacements(request);
      }
      return client.run(request);
    },
    enabled,
  });
}

function usePerformanceAnalyzerClient() {
  const { session } = useShigoSession();
  const config = readShigoAppConfig();
  if (!session) throw new Error('Shigo session is required.');
  return createPerformanceAnalyzerClient({
    config: { apiBaseUrl: config.apiBaseUrl, networkId: config.networkId },
    accessToken: session.accessToken,
  });
}
